// extracted by mini-css-extract-plugin
module.exports = {"rule":"NewForm_rule__Xbobe","stripe":"NewForm_stripe__3HgaT","stripeLead":"NewForm_stripeLead__305vA","card":"NewForm_card__Ypya0","error":"NewForm_error__2g5Qf"};